import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {LoginComponent} from '@app/index/login/login.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {Store} from '@ngrx/store';
import {ForgotPasswordComponent} from '@app/index/login/forgot-password.component';
import {MatCard, MatCardContent} from '@angular/material/card';
import {RegistrationActions} from '@store/registration/registration.actions';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';

@Component({
  selector: 'px-index',
  host: {
    class: 'flex flex-col flex-1'
  },
  templateUrl: './index.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoginComponent, ForgotPasswordComponent, SelectPipe, MatCard, MatCardContent, LinkButtonComponent]
})
export class IndexComponent {
  public readonly organizationSelectors = OrganizationSelectors.Auth;
  private readonly store = inject(Store);

  public isForgotPassword: boolean;

  public forgotPasswordRequest(): void {
    this.isForgotPassword = true;
  }

  public onClickCreateAccount(): void {
    this.store.dispatch(RegistrationActions.showCreateAccount());
  }

  public goBackToLogin(): void {
    this.isForgotPassword = false;
  }
}
